module.exports = __webpack_public_path__ + "static/media/auto.3a0b2aea.svg";